import { Component } from 'react';
import Modal from 'react-modal';
import { AlertModal } from '../../components';
import s from './HostStyles.module.scss';

const options = (selected, handleSubmit, handleClose) => {
    const OPTIONS = {
        support: {
            textOptions: [{ text: 'Let us know if you have a question or are experiencing an issue with the VMS.', className: 'className' }],
            buttonText: 'Email Support',
            handleClose,
            handleSubmit,
            icon: 'icon-supportheadphones',
            iconColor: 'gray',
            name: 'alert',
            title: 'Contact Support',
        },
        checkbox: {
            buttonText: 'Continue',
            handleClose,
            handleSubmit,
            icon: 'icon-circle-check',
            iconColor: 'green',
            name: 'alert',
            title: 'Success!',
        },
        saving: {
            buttonText: 'Continue',
            textOptions: [{ text: 'Please wait for saving to complete.' }],
            handleClose,
            handleSubmit: handleClose,
            icon: 'icon-loader',
            iconColor: 'gray',
            name: 'alert',
            title: 'Unsaved changes for current venue',
        },
    };

    return OPTIONS[selected];
};

export default class FormHost extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedOption: 'support',
            isOpen: false,
        };
    }

    openModal = () => {
        this.setState({ isOpen: true });
    };

    closeModal = () => this.setState({ isOpen: false });

    handleSubmit = () => {
        if (this.state.selectedOption === 'support') window.open('mailto:vmstest@locuslabs.com');
        this.closeModal();
    };

    handleOptionChange = changeEvent => {
        this.setState({ selectedOption: changeEvent.target.value });
    };

    renderInputForm = () => (
        <form className={s.formHost} onSubmit={() => {}} style={{ margin: '10px' }}>
            <div>Input Options</div>
            <input type="radio" value="support" name="options" checked={this.state.selectedOption === 'support'} onChange={this.handleOptionChange} />
            Support
            <br />
            <input type="radio" value="checkbox" name="options" checked={this.state.selectedOption === 'checkbox'} onChange={this.handleOptionChange} />
            Checkbox
            <br />
            <input type="radio" value="saving" name="options" checked={this.state.selectedOption === 'saving'} onChange={this.handleOptionChange} />
            Saving
            <br />
        </form>
    );

    render() {
        const { isOpen } = this.state;

        return (
            <div className={s.editor}>
                <button type="button" onClick={this.openModal}>
                    Show Alert
                </button>
                {this.renderInputForm()}
                <Modal className={s.modal} overlayClassName={s.overlay} isOpen={isOpen}>
                    <AlertModal options={options(this.state.selectedOption, this.handleSubmit, this.closeModal)} />
                </Modal>
            </div>
        );
    }
}
